import { render, staticRenderFns } from "./slot-picker.mpx?vue&type=template&id=77a54cb4&isComponent&outputPath=components%2Fslot-pickerbc673572%2Findex"
import script from "./slot-picker.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fslot-pickerbc673572%2Findex"
export * from "./slot-picker.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fslot-pickerbc673572%2Findex"
import style0 from "./slot-picker.mpx?vue&type=style&index=0&id=77a54cb4&prod&lang=stylus&mpxStyleOptions=%7B%22scoped%22%3Atrue%2C%22mid%22%3A%22_bc673572%22%7D&isComponent&outputPath=components%2Fslot-pickerbc673572%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports